import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-How-We-Calculate-FMV',
    templateUrl: './How-We-Calculate-FMV.component.html',
    styleUrls: ['./How-We-Calculate-FMV.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class HowWeCalculateFMVComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
